import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plashka" }
const _hoisted_2 = { class: "plashka__header" }
const _hoisted_3 = { class: "plashka__name" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "plashka__status" }
const _hoisted_6 = { class: "plashka__content" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, "1", -1)

import { ref, computed, onMounted, watch } from "vue";

// Определение пропсов компонента

export default /*#__PURE__*/_defineComponent({
  __name: 'plashka',
  props: {
  isCompact: { type: Boolean, default: true }, // Исправлено "value" на "default"
  name: { type: String, default: "" },
},
  emits: ["clickLogout", "update:message"],
  setup(__props, { emit: emits }) {

const props = __props;



// Определение эмиттеров событий компонента


// Отслеживание изменений пропса isCompact
watch(
  () => props.isCompact,
  () => {
    if (props.isCompact) {
      console.log("Свойство isCompact поменялось на true");
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "name", {}, () => [
          _createElementVNode("span", { title: __props.name }, _toDisplayString(__props.name), 9, _hoisted_4)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "status")
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _hoisted_7
      ])
    ])
  ]))
}
}

})